import { StoryblokServerComponent } from '@storyblok/react/rsc';
import ToggleTargetClient from '@/components/ToggleTargetClient';
import { getRequestContext } from '@/lib/request-context';

/**
 * Server wrapper for a toggle target. Its `body` holds nested bloks (server
 * components), so they're rendered here and handed to the client component,
 * which shows or hides them based on the matching Toggle's current selection.
 */
const ToggleTarget = ({ blok }) => {
  const children = (blok.body || []).map((nestedBlok) => (
    <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
  ));

  // What to show before any JavaScript runs. The control lives elsewhere in the
  // tree, so the page records each group's starting option up front
  // (collectToggleDefaults); with no record, assume 'primary' as before.
  const initialSelection = getRequestContext().toggleDefaults?.[blok.group] || 'primary';

  return (
    <ToggleTargetClient blok={blok} initialSelection={initialSelection}>
      {children}
    </ToggleTargetClient>
  );
};

export default ToggleTarget;
